export default __webpack_public_path__ + "static/media/save detail.85293dd6.jpg";